export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      sysAdminDashboard: {
        serviceCount:  1,
        activiationRate: 28,
        locationCount: 35,
        noticeCount: 123
      },
      serviceTandouDashboard: {
        locationInfo: {
          registeredLocationCount: 985,
          activatedLocationCount: 211,
          locationActiveInfo: {
            yearMonth: "2021年03月",
            dailyActiveInfo: [
              {
                activedate: "2021年03月01日",
                activeCount: 15
              }
            ]    
          }
        },
        spAppInfo: {
          linkedSpCount: 985,
          spAppLaunchInfo: {
            yearMonth: "2021年03月",
            dailyLaunchInfo: [
              {
                launchDate: "2021年03月01日",
                launchCount: 15
              }
            ]    
          }
        }
      }
    }
  }
}